import React from "react";

const sizes = {
  "2xl": "text-[22px] font-bold",
  xl: "text-xl font-bold",
  s: "text-xs font-bold",
  md: "text-sm font-bold",
  xs: "text-[10px] font-bold",
  lg: "text-base font-bold",
};

const Heading = ({ children, className = "", size = "md", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`text-blue_gray-400_01 font-roboto ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
